export const name = 'mpaNavigation' as const

export const MpaNavigationSymbol = Symbol('MpaNavigationSymbol')
